import { useYandexMetrika } from 'yandex-metrika-vue3'

const metrika = useYandexMetrika()

export const reachGoal = (target: string) => {
  if (process.env.VUE_APP_METRIKA === 'development') console.info(`Достигнута цель метрики: ${target}`)
  metrika.reachGoal(target)
}
